module.exports = __webpack_public_path__ + "img/thumb-baiser-d-ecumes.53f4bfca.jpg";